export const MAKEMAKE_LIVE_MONTHS = [
    {
        id: "enero",
        date: "2026-01-01",
        name: {
            default: "Enero",
            translationPath: "meses.enero",
        },
        visible: true,
    },
    {
        id: "febrero",
        date: "2026-02-01",
        name: {
            default: "Febrero",
            translationPath: "meses.febrero",
        },
        visible: true,
    },
    {
        id: "marzo",
        date: "2026-03-01",
        name: {
            default: "Marzo",
            translationPath: "meses.marzo",
        },
        visible: true,
    },
    {
        id: "abril",
        date: "2026-04-01",
        name: {
            default: "Abril",
            translationPath: "meses.abril",
        },
        visible: true,
    },
    {
        id: "mayo",
        date: "2026-05-01",
        name: {
            default: "Mayo",
            translationPath: "meses.mayo",
        },
        visible: true,
    },
    {
        id: "junio",
        date: "2026-06-01",
        name: {
            default: "Junio",
            translationPath: "meses.junio",
        },
        visible: true,
    },
    {
        id: "julio",
        date: "2026-07-01",
        name: {
            default: "Julio",
            translationPath: "meses.julio",
        },
        visible: true,
    },
    {
        id: "agosto",
        date: "2026-08-01",
        name: {
            default: "Agosto",
            translationPath: "meses.agosto",
        },
        visible: true,
    },
    {
        id: "septiembre",
        date: "2026-09-01",
        name: {
            default: "Septiembre",
            translationPath: "meses.septiembre",
        },
        visible: true,
    },
    {
        id: "octubre",
        date: "2026-10-01",
        name: {
            default: "Octubre",
            translationPath: "meses.octubre",
        },
        visible: true,
    },
    {
        id: "noviembre",
        date: "2026-11-01",
        name: {
            default: "Noviembre",
            translationPath: "meses.noviembre",
        },
        visible: true,
    },
    {
        id: "diciembre",
        date: "2026-12-01",
        name: {
            default: "Diciembre",
            translationPath: "meses.diciembre",
        },
        visible: true,
    },
];

export const MAKEMAKE_LIVE_PLAYLISTS = [
    {
        id: "libros-informativos",
        name: { default: "Libros informativos para niños", translationPath: "makemake_en_vivo.destacados.tarjeta.libros_informativos" },
        url: "https://www.youtube.com/embed?listType=playlist&list=PLOzDFiyCElH6xb3a_MOkXr3ULwRAzk8Cx",
        img: "",
        onMobile: true
    },
    {
        id: "hora-del-cuento",
        name: { default: "Hora del Cuento Bilingüe con René Colato Laínez", translationPath: "makemake_en_vivo.destacados.tarjeta.hora_del_cuento" },
        url: "https://www.youtube.com/embed?listType=playlist&list=PLOzDFiyCElH5SyvmvYW_SAynwLkY9VA7f",
        img: "",
        onMobile: true
    },
    {
        id: "taller-de-manga",
        name: { default: "Taller de dibujo manga con Javier Rovella", translationPath: "makemake_en_vivo.destacados.tarjeta.taller_de_manga" },
        url: "https://www.youtube.com/embed?listType=playlist&list=PLOzDFiyCElH59Z9y4_7I2STH2bUw_g_ek",
        img: "",
        onMobile: true
    },
    {
        id: "festival-musical",
        name: { default: "Festival musical con MakeMake", translationPath: "makemake_en_vivo.destacados.tarjeta.festival_musical" },
        url: "https://www.youtube.com/embed?listType=playlist&list=PLOzDFiyCElH6d4soLzEjbXBouQ7lqvc3u",
        img: "",
        onMobile: true
    },
    {
        id: "clasicos-de-literatura",
        name: { default: "¿Por qué leer los clásicos de la literatura? ", translationPath: "makemake_en_vivo.destacados.tarjeta.clasicos_de_literatura" },
        url: "https://www.youtube.com/embed/7mJYR3rfWfA?si=3qRy7mDYRejIcaNL",
        img: "",
        onMobile: true
    },
    /* {
        id: "2023",
        name: { default: "Programación 2023", translationPath: "makemake_en_vivo.destacados.tarjeta.programacion_2023" },
        url: "https://www.youtube.com/playlist?list=PLOzDFiyCElH5mo8jNZ9fLh-Zr6VVewrKB",
        img: "/img/club-makemake/programacion/programacion-2023.jpg",
    },
    {
        id: "2022",
        name: { default: "Programación 2022", translationPath: "makemake_en_vivo.destacados.tarjeta.programacion_2022" },
        url: "https://www.youtube.com/playlist?list=PLOzDFiyCElH6qdpXPwpaSZCcwS18rTkHG",
        img: "/img/club-makemake/programacion/programacion-2022.jpg",
    },
    {
        id: "2021",
        name: { default: "Programación 2021", translationPath: "makemake_en_vivo.destacados.tarjeta.programacion_2021" },
        url: "https://www.youtube.com/playlist?list=PLOzDFiyCElH7zPY7KCBiHi6oopJvO0AYx",
        img: "/img/club-makemake/programacion/programacion-2021.jpg",
    }, */
];